import { useState } from 'react';

interface FallbackImageProps {
  srcs: string[];
  alt: string;
  className?: string;
  loading?: 'eager' | 'lazy';
}

const FallbackImage = ({ srcs, alt, className, loading = 'lazy' }: FallbackImageProps) => {
  const [index, setIndex] = useState(0);

  const activeSrc = srcs[index] || '/pictures/LOGO.png';

  return (
    <img
      src={activeSrc}
      alt={alt}
      className={className}
      loading={loading}
      onError={() => {
        if (index < srcs.length - 1) {
          setIndex(index + 1);
        }
      }}
    />
  );
};

export default FallbackImage;
